import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProductName } from '../definitions/base.definitions';
import { Environment } from '../definitions/environment.definitions';
import { Icon, IconItem } from '../definitions/icon.definitions';

@Injectable({
    providedIn: 'root'
})
export class VariantManager {
    // 1) Start with everything set to false/defaults
    private _hasRepertoire: boolean = false;
    private _hasLendingLibrary: boolean = false;
    private _hasHomeworkSubmission: boolean = false;
    private _hasPracticeLog: boolean = false;
    private _studentTableHasSchoolColumn: boolean = false;
    private _studentCreationHasSchoolField: boolean = false;
    private _studentCreationDefaultStudentAdult: boolean = false;
    private _subjectIconName: IconItem = Icon.Common.PersonArtistOutline;
    private _subjectIconSolidName: IconItem = Icon.Common.MusicNoteDouble;

    private _appLanguage: string = 'en';

    // 2) then, enable features based on brand!
    // chart can be found at:
    // https://bookstack.port443.io/books/development/page/brand-specific-configurations#bkmrk-features
    constructor (private _Environment: Environment,
        private _Router: Router) {
        if (this._Environment.Application?.ProductName) {
            switch (this._Environment.Application.ProductName) {
                case ProductName.Local: 
                case ProductName.Test443: 
                    this._hasRepertoire = true;
                    this._hasLendingLibrary = true;
                    this._studentTableHasSchoolColumn = true;
                    this._studentCreationHasSchoolField = true;
                    this._hasHomeworkSubmission = true;
                    this._hasPracticeLog = true;
                    break;
                case ProductName.MyMusicStaff:
                    this._hasRepertoire = true;
                    this._hasLendingLibrary = true;
                    this._studentTableHasSchoolColumn = true;
                    this._studentCreationHasSchoolField = true;
                    this._hasPracticeLog = true;
                    break;
                case ProductName.TutorBird:
                    this._hasLendingLibrary = true;
                    this._hasHomeworkSubmission = true;
                    this._studentTableHasSchoolColumn = true;
                    this._studentCreationHasSchoolField = true;
                    this._subjectIconName = Icon.Common.BookClosedOutline;
                    this._subjectIconSolidName = Icon.Common.BookClosed;
                    break;
                case ProductName.AthletaDesk:
                    this._studentCreationDefaultStudentAdult = true;
                    this._subjectIconName = Icon.Common.DirectionsRun;
                    this._subjectIconSolidName = Icon.Common.DirectionsRun;
                    this._hasPracticeLog = true;
                    break;
            }
        }
        this.ParseCurrentAppLanguageFromUrl();
    }

    // THIS IS FOR TP ONLY!
    RouteToCurrentPageWithDifferentLocale(locale: string): void {
        window.location.replace(this._Environment.Application.BaseUrls.App + this._Environment.Application.BaseHref! + locale + this._Router.url);
    }

    private ParseCurrentAppLanguageFromUrl(): void {
        const languageFromUrl: string = window.location.href.split('/')[5];
        // https://app.test443.com/Teacher/v2/en/calendar after splitting this string, language code will be the 5-th element
        if (languageFromUrl) {
            this._appLanguage = languageFromUrl;
        }
    }

    get hasRepertoire(): boolean {
        return this._hasRepertoire;
    }

    get hasLendingLibrary(): boolean {
        return this._hasLendingLibrary;
    }

    get studentTableHasSchoolColumn(): boolean {
        return this._studentTableHasSchoolColumn;
    }

    get studentCreationHasSchoolField(): boolean {
        return this._studentCreationHasSchoolField;
    }

    get studentCreationDefaultStudentAdult(): boolean {
        return this._studentCreationDefaultStudentAdult;
    }

    get subjectIconName(): IconItem {
        return this._subjectIconName;
    }

    get subjectIconSolidName(): IconItem {
        return this._subjectIconSolidName;
    }

    get appLanguage(): string {
        return this._appLanguage;
    }

    get hasHomeworkSubmission(): boolean {
        return this._hasHomeworkSubmission;
    }

    get hasPracticeLog(): boolean {
        return this._hasPracticeLog;
    }
}
